export let hotkeyOne = "_GoMAd";
export let hotkeyTwo = "AWPJDd";
export let hotkeyThree = "SW2gQd";
export let hotkeyFour = "Ck4kQd";
export let hotkeyFive = "eqeRMd";
export let hotkeySix = "KIj6Cd";
export let hotkeySeven = "Tv16Le";
export let hotkeyEight = "HkQ8Ge";
export let hotkeyNine = "WUL9ab";
export default {hotkeyOne,hotkeyTwo,hotkeyThree,hotkeyFour,hotkeyFive,hotkeySix,hotkeySeven,hotkeyEight,hotkeyNine};